import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { dispatchConst, GET_API_DATA } from "./type";

export const resetState = createAction("main/resetState");

export const middleware = createAsyncThunk(
  GET_API_DATA,
  async (action, { dispatch }) => {
    try {
      console.log("actionIn middleware", action);
      return action;
    } catch (error) {
      return error;
    }
  }
);

const initialState = {
  sampleData: "",
  specialities: [],
};

const mainSlice = createSlice({
  name: "main",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(middleware.pending, (state, action) => {});

    builder.addCase(middleware.fulfilled, (state, { payload }) => {
      console.log("middleware.data", payload.data);

      switch (payload.dispatchType) {
        case dispatchConst.sampleDisp:
          state.sampleData = payload.data;
          break;

        case dispatchConst.specialities:
          state.specialities = payload.data;
          break;
      }
    });

    builder.addCase(middleware.rejected, (state, action) => {
      console.log("middleware.rejected", action);
    });

    // Handle the reset action
    builder.addCase(resetState, () => initialState);
  },
});

const mainReducer = mainSlice.reducer;

export default mainReducer;
